import React, { useEffect } from 'react';
import { StyledSelect } from './Styles';
import Option from './../option';

const Select = ({
  valueProp,
  textProp,
  currentValue,
  data,
  noneSelectedText,
  onChange,
}) => {
  return (
    <StyledSelect onChange={onChange} value={currentValue}>
      {noneSelectedText && <Option key="" value="" text={noneSelectedText} />}
      {data.map((item, index) => (
        <Option
          key={item[valueProp]}
          value={item[valueProp]}
          text={item[textProp]}
        />
      ))}
    </StyledSelect>
  );
};

Select.defaultProps = {};
Select.propTypes = {};

export default Select;
